import styled from "styled-components"
import Text from "../atoms/Text"
import WordChipList from "./WordChipList"
import AddMeaningChip from "../atoms/AddMeaningChip"
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  border-top: 2px solid ${({ theme }) => theme.colors.neutral[300]};
  border-bottom: 2px solid ${({ theme }) => theme.colors.neutral[300]};
  margin-top: 16px;
`
const SectionHeader = styled.div`
  display:flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 26px;
`
const TitleArea = styled.div`
  display: flex;
  justify-contnet: center;
  align-items: center;
  gap: 4px;
`
const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: none;
  border: none;
  cursor: pointer;
`
const HelpIcon = styled(HelpOutlineOutlinedIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`
const ExpandedSection = ({ hrId, drId, rates, onMeaningChange, onAddMeaningClick, onRemoveAddedMeaning, word, onHelpClick }) => {
  return (
    <Wrapper>
      <SectionHeader>
        <TitleArea>
          <Text weight="medium">추천단어</Text>
          <HelpButton onClick={onHelpClick}>
            <HelpIcon sx={{ fontSize: 16 }}/>
          </HelpButton>
        </TitleArea>
        <Text variant="caption" color="alternative">AI가 분석한 결과, 이 의미단어일 가능성이 높아요.</Text>
      </SectionHeader>
  
      <WordChipList
        hrId={hrId}
        drId={drId}
        rates={rates}
        selectedMeaning={word.selectedMeaning}
        addMeaning={word.addedMeaning}
        onSelect={(meaning, rank) => onMeaningChange(word.key, meaning, rank)}
        onRemove={() => onRemoveAddedMeaning(word.key, drId)}
        onAdd={onAddMeaningClick}
      />
      
      <AddMeaningChip 
        onAdd={onAddMeaningClick}
        label="의미단어 추가하기"
      />
    </Wrapper>
    )
  }

export default ExpandedSection
